module.exports = __webpack_public_path__ + "static/media/logoKJCropped.cca90cc6.png";